<template>
	<div class="row mb-3">
		<div class="col-12 col-sm-4">
			<div class="d-flex body-strong text-grey-900 text-start mb-2">
				<span v-if="currentPackConfig.length > 0">
					{{ content.planningSummary_options_optionTitle }}
				</span>
				<span v-else>
					{{ content.planner_resumeNoOptions }}
				</span>
			</div>
			<div class="body text-start text-grey-700 mb-2 mb-md-0">
				<span v-if="currentPackConfig.length > 0">
					{{ content.planningSummary_options_optionSubtitle }}
				</span>
				<span v-else>
					{{ content.planner_resumeAddOption }}
				</span>
			</div>
		</div>
		<!-- hide for now, but will need later when the design and planned behavior are finalized -->
		<!-- <div class="d-none d-sm-flex flex-sm-column col-8"> -->
		<div
			class="d-flex flex-column col-12 col-sm-8 body text-grey-900 text-start"
		>
			<span
				class="my-1 my-md-0 d-flex flex-row flex-nowrap align-items-center"
				v-for="(optionName, option_i) in currentPackConfig"
				:key="option_i"
			>
				<div class="me-1">
					<svg :height="16" :width="16" class="icon">
						<use :xlink:href="`#___icon___${optionName}`"></use>
					</svg>
				</div>
				<span class="me-1"
					>{{ content[`planningSummary_options_${optionName}`] }}
				</span>
				<span>
					<ParticipantsTotals
						:participants="participants"
						:content="content"
						:optionName="optionName"
						:variant="variant"
						:displayWithIcons="true"
						:excludedAges="[1]"
					/>
				</span>
			</span>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import ParticipantsTotals from "@/vue/planning/components/common/participantsTotals.vue";
import packOptionConfig from "@/config/packOptionsConfig.js";
import { isCS } from "@/vue/planning/logic/cs";
import store from "@/vue/planning/store/store";

export default {
	store,
	name: "Options",
	components: {
		ParticipantsTotals,
	},
	props: {
		variant: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	data() {
		return {
			packOptionConfig: packOptionConfig,
			data: {},
		};
	},
	computed: {
		...mapState(["packCode", "content", "participants"]),

		currentPackConfig() {
			return this.packOptionConfig[this.packCode] || [];
		},
	},

	methods: {
		isCS,
	},
};
</script>

<style scoped></style>
